const colors = {
  primary: "#FFC30B", // Honey Yellow
  secondary: "#1C1C1C", // Bee Black
  ternary: "#FFB74D", // Wax Amber
  quaternary: "#8B4513", // Hive Brown
  quinary: "#4CAF50", // Nature Green

  backgroundMain: "#FFFFEA", // Light Yellow
  backgroundSecondary: "#FFFFFF", // Sky Blue
  backgroundTernary: "#FFF8DC", // Gold Yellow
  backgroundQuaternary: "#DFF0D8", // Orange

  textMain: "#1C1C1C", // Bee Black
  textSecondary: "#8B4513", // Hive Brown
  textTernary: "#4CAF50", // Nature Green
  textMuted: "#5C4A3B", // Softened Hive Brown, for long-form body text

  border: "#D2B48C", // Earthy Beige
  button: "#FFC30B", // Honey Yellow
  buttonHover: "#FF8C00", // Flower Blossom
  captions: "#4CAF50", // Nature Green

  error: "#FF4C4C", // Darker Pale Red
};

export default colors;
